import {useState} from 'react'
import { Col, Container, Row } from "react-bootstrap"
import linkedInLogo from "../assets/img/nav-icon1.svg"
import emailIcon from "../assets/img/email_icon.png"

export const Contact = (props) => {
    const formInitialDetails = {
        name: '',
        email: '',
        message: ''
    }
    
    const [formDetails, setFormDetails] = useState(formInitialDetails)
    const [buttonText, setButtonText] = useState('Send')
    const [buttonState, setButtonState] = useState('')

    const onFormUpdate = (category, value) => {
        setFormDetails({
            ...formDetails,
            [category]: value
        })
    }

    const resetButton = () => {
        setTimeout(() => {
            setButtonText('Send')
            setButtonState('')
        }, 3000)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        const { name, email, message } = formDetails

        if (!name || !email || !message) {
            setButtonText("Fill all fields!")
            setButtonState('error')
            resetButton()
            return
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!emailRegex.test(email)) {
            setButtonText("Invalid email!")
            setButtonState('error')
            resetButton()
            return
        }

        setButtonText("Sending...")

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL || ''}/contact`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formDetails)
            })

            const result = await response.json()

            if (result.code === 200) {
                setButtonText("Message Sent!")
                setButtonState('success')
                setFormDetails(formInitialDetails)
                resetButton()
            } else {
                setButtonText("Something went wrong")
                setButtonState('error')
                resetButton()
            }
        } catch (error) {
            setButtonText("Something went wrong")
            setButtonState('error')
            resetButton()
        }
    }

    const handleLinkedInClick = () => {
        window.open("https://www.linkedin.com/in/joao-lindeza/", '_blank');
    }

    return (
        <section className="contact" id="connect">
            <Container>
                <h2>
                    Get in Touch!
                </h2>
                <Row className="align-items-center">
                    <Col md={6} className= {props.windowWidth <= 767 ? "separator-under" : "separator-after"}>
                        <form onSubmit={(e) => handleSubmit(e)}>
                            <Row>
                                <Col sm={12} className= { props.windowWidth <= 575 ? "px-4" : "px-1" }>
                                    <input type="text" value={formDetails.name} placeholder="Name" onChange={(e) => onFormUpdate('name', e.target.value)} />
                                </Col>
                                <Col sm={12} className= { props.windowWidth <= 575 ? "px-4" : "px-1" }>
                                    <input type="email" value={formDetails.email} placeholder="Email" onChange={(e) => onFormUpdate('email', e.target.value)} />
                                </Col>
                                <Col className= { props.windowWidth <= 575 ? "px-4 contact-submit-area" : "px-1 contact-submit-area" }>
                                    <textarea row="6" value={formDetails.message} placeholder="Message" onChange={(e) => onFormUpdate('message', e.target.value)} />
                                    <button disabled={!!buttonState} className={buttonState ? `btn-${buttonState}` : ''}><span>{buttonText}</span></button>
                                </Col>
                            </Row>
                        </form>
                    </Col>
                    <Col md={6}>
                         <Row>
                            <div className= {props.windowWidth <= 767 ? "contact-personals-mobile" : "contact-personals-wide"}>
                                <div className="contact-line"><img className="contact-logo" src={emailIcon} alt="E-mail"/><h5>joao.lindeza@hotmail.com</h5></div>
                                <div className="contact-separator"></div>
                                <div className="contact-line" onClick={() => handleLinkedInClick()}><img className="contact-logo" src={linkedInLogo} alt="Linked In"/><h5>joao-lindeza</h5></div>
                            </div>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}